.meter {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-inline-size: 0;
}

.header {
  display: flex;
  gap: var(--space-2);
  align-items: baseline;
  justify-content: space-between;
}

.label {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.hiddenLabel {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.value {
  color: var(--color-text);
  font-size: var(--text-sm);
  font-variant-numeric: var(--numeric);
  white-space: nowrap;
}

.track {
  overflow: hidden;
  block-size: var(--space-2);
  border-radius: var(--radius-full);
  background: var(--color-surface-active);
}

.meter[data-size="sm"] .track {
  block-size: var(--space-1);
}

.indicator {
  block-size: 100%;
  border-radius: var(--radius-full);
  background: var(--color-success);
}

.meter[data-level="low"] .indicator {
  background: var(--color-warning);
}

.meter[data-level="empty"] .indicator {
  background: var(--color-danger);
}

.meter[data-level="empty"] .value {
  color: var(--color-danger);
}
